import { FC, useMemo } from 'react';
import { EasyField, RadioGroup, useForm } from 'react-bootstrap-formutil';
import BackNextButtons from 'components/BackNextButtons';
import BorderRadio from 'components/BorderRadio';
import FormGroup from 'components/FormGroup';
import { AccountFormutil, CategoryFormutil } from 'modules/Open';
import values from 'stores/values';
import { CategoryEnum, CustomerTypeEnum, IdTypeEnum } from 'types/customer';
import { isEmptyValue } from 'utils/helper';
import withProgressForm, { ProgressFormProps } from 'utils/withProgressForm';
import { individualAccountOptions, iraCustomerTypeOptions } from './helper';
import { TaxTypeEnum } from './type';

/**
 *  账户选择组件
 */
const Account: FC<ProgressFormProps> = ({ onSubmit }) => {
    const { category, temporaryOpenType: storageTempOpenType } =
        values.getParams<AccountFormutil & CategoryFormutil>() || {};
    const {
        $params: { temporary_tax_type, customer_type }
    } = useForm<AccountFormutil>();
    const isIRA = category === CategoryEnum.IRA;
    const accountOptions = useMemo(() => (isIRA ? iraCustomerTypeOptions : individualAccountOptions), [isIRA]);
    const handleSubmit = (ev: React.FormEvent) => {
        if (category === CategoryEnum.INDIVIDUAL && temporary_tax_type === TaxTypeEnum.NON_SSN) {
            onSubmit('../ocr', ev);
        } else {
            onSubmit('../baseinfo', ev);
        }
    };

    return (
        <form noValidate onSubmit={handleSubmit}>
            <h3 className="open-title mb-4">{__('CHOOSE YOUR ACCOUNT TYPE')}</h3>
            <FormGroup
                name={isIRA ? 'customer_type' : 'temporary_tax_type'}
                checker={value => !isEmptyValue(value) || (isIRA ? __('请选择退休金账户类型') : __('请选择税务身份'))}
                $parser={value => (isIRA ? Number(value) : value)}
                $formatter={value => (isIRA ? String(value) : value)}>
                <RadioGroup>
                    {accountOptions.map(({ value, title, description }) => (
                        <BorderRadio
                            key={value}
                            // 这里需要转换成String, 是因为FormCheck checked比较的是dom上的value，只能是string
                            value={String(value)}
                            id={`temporary_tax_type_${value}`}
                            active={isIRA ? value === customer_type : value === temporary_tax_type}
                            labelOptions={{
                                title,
                                description
                            }}
                            checkedType="radio"
                        />
                    ))}
                </RadioGroup>
            </FormGroup>
            {/* category是Individual的情况下， customer_type默认是Individual */}
            {!isIRA && !!temporary_tax_type && (
                <EasyField type="hidden" name="customer_type" $defaultValue={CustomerTypeEnum.INDIVIDUAL} />
            )}
            {/* SSN或者IRA开户默认证件类型就是ssn_ids，非SSN开户在下一步OCR流程中选择证件类型  */}
            {(temporary_tax_type === TaxTypeEnum.SSN || isIRA) && (
                <EasyField type="hidden" name="id_type" $defaultValue={IdTypeEnum.SSN_IDS} />
            )}
            <BackNextButtons hidePrev={!!storageTempOpenType} sticky />
        </form>
    );
};

export default withProgressForm({
    id: 'account',
    basePath: 'open',
    ensure: ['category'],
    // 账户类型/税务身份发生变化，清空SSN与非SSN开户流程差异页面的数据
    effect: ['ocr', 'baseinfo', 'baseinfo2', 'address', 'deliveryAddress', 'exemption'],
    showProgressBar: false
})(Account);

export * from './type';
